import {Component, OnInit} from '@angular/core';
import {BreadcrumbService} from '../../../../breadcrumb.service';
import {ProjectBranchService} from '../../../../core/services';
import {TokenService} from '../../../../core/auth';
import {ActivatedRoute} from '@angular/router';
import {ImportTransactionRequest, Project, ProjectAccess, ProjectBranch} from '../../../../core/models';
import {ProjectSidebarService} from '../../../../projectsidebar.service';
import {ProjectTransactionService} from '../../../../core/services/projectTranscation.service';

@Component({
  selector: 'app-project-branch-details',
  templateUrl: './project-branch-details.page.html'
})
export class ProjectBranchDetailsPage implements OnInit {
  project: Project;
  branch: ProjectBranch;
  branchOrig: ProjectBranch;
  authUser = this.token.whoAmI();
  loading = false;
  projectId: string;
  branchId: string;
  userProjectAccess: ProjectAccess;
  importTransactionId: string;

  constructor(
    private route: ActivatedRoute,
    private token: TokenService,
    private projectBranchService: ProjectBranchService,
    private breadcrumbService: BreadcrumbService,
    private projectSidebarService: ProjectSidebarService,
    private projectTransactionService: ProjectTransactionService
  ) {
  }

  ngOnInit() {
    this.loading = true;
    this.route.parent.params.subscribe((params) => {
      this.projectId = params.id;
    });

    this.route.params.subscribe(data => {
        this.branchOrig = {id: data.id};
        this.branchId = data.id;
        this.route.parent.data.subscribe(data => {
          if (data.project) {
            this.project = Object.assign({}, data.project);
            this.userProjectAccess = Object.assign({}, data.userProjectAccess);
            this.loadProjectBranch(this.branchOrig.id);
            this.projectSidebarService.setProject(this.project);
          }
          this.loading = false;
        });
      },
      error => {
        this.loading = false;
      });
  }

  loadProjectBranch(id) {
    this.loading = true;
    this.projectBranchService.getOne(id).subscribe(
      branchData => {
        delete this.loading;
        this.branchOrig = Object.assign({}, branchData);
        this.branch = Object.assign({}, branchData);
        this.breadcrumbService.setItems([
          {label: 'projects', routerLink: ['/project', 'list']},
          {label: this.project.name},
          {
            label: 'branches',
            routerLink: [
              '/project',
              this.project.id,
              'branch',
              'list'
            ]
          },
          {label: this.branchOrig.name}
        ]);
      },
      error => {
        delete this.loading;
      }
    );
  }

  importTransaction() {
    const request = new ImportTransactionRequest(
      this.project.id,
      this.branch.id,
      this.importTransactionId
    );
    this.projectTransactionService.importTransaction(request).subscribe(data => {
    });
    this.importTransactionId = '';
  }
}
